import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../../css/page-auth.css";
import { useAuth } from "../../Context/store/context.js";
import DocumentTitle from '../../../documentTitle.js';
import { _get, _post } from "../../../apiClient.js";
import { _showToast } from "../../../toastHelper.js";

// function to handle the refresh
export function getRootPath(url) {
  const urlParts = url.split("/");
  return `/${urlParts[1]}`;
}

export default function LogIn() {
  DocumentTitle("Verify Otp")
  const { showLoader, hideLoader, setUsername } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");

  // login functionality
  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (email != "") {
      showLoader();
      await callVerify();
    }
    else
      _showToast("Please provide data for all required fields", "info");
  };

  const callVerify = async () => {
    let verify = {
      "username": searchParams.get("name"),
      "otp": otp,
    };

    return await _post(`/auth/verify-otp`, verify, null, false)
      .then(response => {
        hideLoader();
        _showToast("Otp verified successfully", "success");
        setUsername(verify.username);
        navigate('/reset-password');
        return 1;
      }).catch(error => {
        hideLoader();
        _showToast("Invalid Otp", "error");
        return 1;
      });
  }

  return (
    <div className="authentication-wrapper authentication-cover authentication-bg">
      <div className="authentication-inner row">
        {/* <!-- /Left Text --> */}
        <div className="d-none d-lg-flex col-lg-8 p-0">
          <div className="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center bg1 ">
            <div className="hero-banner hero-style-2 bg-image">
              <div className="banner-gallery">
                <div
                  className="thumbnail thumbnail-1"
                  data-sal-delay="500"
                  data-sal="slide-up"
                  data-sal-duration="1000"
                >
                  <img src="images/birthday_events.jpg" alt="" />
                </div>
                <div
                  className="thumbnail thumbnail-2"
                  data-sal-delay="500"
                  data-sal="slide-down"
                  data-sal-duration="1000"
                >
                  <img src="/images/cake_birthday.jpg" alt="" />
                </div>
                <div
                  className="online-support"
                  data-sal-delay="600"
                  data-sal="slide-right"
                  data-sal-duration="1000"
                >
                  <div className="inner">
                    <div className="content">
                      <span className="subtitle">INVITD</span>
                      <h4 className="title">
                        ONLINE INVITATION MAKER
                      </h4>
                    </div>
                  </div>
                </div>
                <ul className="shape-group">
                  <li
                    className="shape-2 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000"
                  >
                    <img data-depth="-2" src="images/shape-12.png" alt="Shape" />
                  </li>
                  <li
                    className="shape-4 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000"
                  >
                    <img data-depth="-2" src="images/shape-04.png" alt="Shape" />
                  </li>
                </ul>
              </div>
            </div>
            <img src="images/bg-image-1.png" alt="" className="platform-bg" />

            <div className="footer bg-footer-theme fcopyright  fs-13 text-center z-index">
              <div className="row">
                <div className="col-md-5">
                  ©{new Date().getFullYear()}, <a
                    href="https://ajsinnovations.in/"
                    className="text-primary"
                    target="_new"
                  >
                    AJS Innovations Pvt. Ltd.
                  </a> All Rights Reserved.
                </div>
                {/* <div className="col-md-7">
                  Software Powered By{" "}
                  <a
                    href=""
                    target="_blank"
                    className="footer-text text-primary fw-medium"
                  >
                    Edit Point India
                  </a>{" "}
                  Private Limited
                </div> */}
                {/* <div className="col-md-5">
                  Developed By{" "}
                  <a
                    href="https://ajsinnovations.in/"
                    className="text-primary"
                    target="_new"
                  >
                    AJS Innovations
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Left Text --> */}

        {/* <!-- Login --> */}
        <div className="d-flex col-12 col-lg-4 align-items-center p-sm-4 p-3">
          <div className="w-px-400 mx-auto">
            {/* <!-- Logo --> */}
            <div className="app-brand mx-6 mb-1">
              <a href="index.html">
                <span className="app-brand-logo demo">
                  <img
                    src="images/logo.png"
                    className="img-fluid my-5 auth-illustration"
                  />
                </span>
              </a>
            </div>
            {/* <!-- /Logo --> */}
            <h3 className="mb-4 fw-bold text-center">ONLINE INVITATION MAKER</h3>

            <>
              <form
                id="formAuthentication"
                className="mb-3"
                onSubmit={handleForgotPassword}
              >
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Verification Code
                  </label>
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                  <input
                    type="text"
                    value={otp}
                    className="form-control"
                    id="email"
                    name="email-username"
                    placeholder="Please enter verification recieved over email or whatsapp"
                    onChange={(e) => setOtp(e.target.value)}
                    autoFocus
                    required
                  />
                </div>
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="col-3 justify-content-center">
                      <button type="submit" className="btn btn-primary d-grid w-30" >
                        Verify
                      </button>
                    </div>
                    <div className=" ">
                      <a href="/login"
                        className="px-0 fs-14 border-none"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        Go back to login
                      </a>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 justify-content-center"></div>
                </div>
              </form>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
